import { arrayRemove, arrayUnion, doc, setDoc, collection, query, where, getDocs, updateDoc } from "firebase/firestore";
import { useCallback, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { auth, db } from "../firebase";
import { useEffect } from "react";
import Document from "./document";
import WhatsApp from "./whatsApp";
import Gala from "./gala";
import Season from "./season";
import Holiday from "./holiday";
import NewSeason from "./newSeason";
import Extermin from "./extermin";
import TicketIcon from "./ticketIcon";

export default function User({u, locations, groups}) {

    const [on, setOn] = useState(false)

    // === NEW: popup zakończenia i stan pracy ===
    const [removeOpen, setRemoveOpen] = useState(false);
    const [removeDate, setRemoveDate] = useState(() => {
      const d = new Date();
      const mm = String(d.getMonth() + 1).padStart(2, "0");
      const dd = String(d.getDate()).padStart(2, "0");
      return `${d.getFullYear()}-${mm}-${dd}`;
    });
    const [working, setWorking] = useState(false);

    const copyToClipboard = (str) => {
        const el = document.createElement('textarea');
        el.value = str;
        el.setAttribute('readonly', '');
        el.style.position = 'absolute';
        el.style.left = '-9999px';
        document.body.appendChild(el);
        el.select();
        el.focus();
        document.execCommand('copy');
        document.body.removeChild(el);
    };
    
    const [whatsApp, setWhatsApp] = useState(false)
    const [gala, setGala] = useState(false)
    const [holiday, setHoliday] = useState(false)
    const [newSeason, setNewSeason] = useState(false)

    const whatsAppSet = (s) => {
        setDoc(doc(db, "users2026", u?.uid), {
            subUsers: {
                [u?.user?.index]: {
                    whatsApp: s
                }
            }
        }, {merge: true})

        setWhatsApp(false)
    }

    function numberToPolishWeekday(num) {
        const days = {
          1: "Poniedziałek",
          2: "Wtorek",
          3: "Środa",
          4: "Czwartek",
          5: "Piątek",
          6: "Sobota",
          7: "Niedziela"
        };
        
        return days[num] || "Niepoprawny numer dnia (1–7)";
    }

const getGroups = useCallback(() => {
  // bezpieczne kopie
  const grpArr = Array.isArray(groups) ? groups : [];
  const locArr = Array.isArray(locations) ? locations : [];

  // prices może nie istnieć lub być puste
  const rawPrices = u?.user?.prices;
  const hasPrices =
    rawPrices && typeof rawPrices === "object" && Object.keys(rawPrices).length > 0;
  const pricesMap = hasPrices ? rawPrices : null;

  const TypeBadge = ({ type }) => {
    let base = {
      fontSize: 10,
      fontWeight: 700,
      padding: "2px 6px",
      borderRadius: 8,
      whiteSpace: "nowrap",
      display: "inline-block",
    };

    if (type === "entry") {
      return (
        <span
          style={{
            ...base,
            background: "rgba(255,99,71,.10)",
            border: "1px solid rgba(255,99,71,.25)",
            color: "#B54708",
          }}
        >
          wejście jednorazowe
        </span>
      );
    }
    if (type === "contract") {
      return (
        <span
          style={{
            ...base,
            background: "rgba(0,69,199,.10)",
            border: "1px solid rgba(0,69,199,.25)",
            color: "#0A66FF",
          }}
        >
          umowa
        </span>
      );
    }
    // missing
    return (
      <span
        style={{
          ...base,
          background: "rgba(220,38,38,.10)",
          border: "1px solid rgba(220,38,38,.25)",
          color: "#B91C1C",
        }}
      >
        brak typu
      </span>
    );
  };

  const resolveType = (gid) => {
    if (!pricesMap) return "missing";
    const v = pricesMap[gid];
    if (v === "entry") return "entry";
    if (v === "contract") return "contract";
    return "missing";
  };

  return (u?.user?.groups || []).map((gId) => {
    const groupData = grpArr.find((x) => x?.id === gId);
    if (!groupData) return null;

    const locationName =
      locArr.find((x) => x?.id === groupData?.location_id)?.name || "";

    const dayData = groupData?.days?.[0];
    const dayInfo = dayData
      ? dayData.custom_name
        ? dayData.custom_name
        : `${numberToPolishWeekday(dayData.weekDay)} - ${dayData.startTime} - ${dayData.endTime} - ${groupData.type} - ${groupData?.id}`
      : "";

    const mtype = resolveType(gId);

    return (
      <div
        key={gId}
        style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 2 }}
      >
        <h3 style={{ fontSize: 12, color: "rgb(30,30,30)", margin: 0 }}>
          {locationName} - {dayInfo}
        </h3>
        <TypeBadge type={mtype} />
      </div>
    );
  });
}, [u, groups, locations]);


    const adultStatus = (u) => {
        setDoc(doc(db, "users2026", u?.uid), {
          subUsers: {
            [u?.user?.index]: {
                adult: true
            }
          }
        }, {merge: true})
    }

    // === NEW: pobranie sesji od daty dla grup usera
    const fetchSessionsForGroupsFromDate = async (facilityId, groupIds = [], fromDate /* YYYY-MM-DD */) => {
      const results = [];
      if (!Array.isArray(groupIds) || groupIds.length === 0) return results;

      // dzielenie na paczki po 10 dla operatora "in"
      const batches = [];
      for (let i = 0; i < groupIds.length; i += 10) {
        const slice = groupIds.slice(i, i + 10);
        const constraints = [
          where("group_id", "in", slice),
          where("date", ">=", fromDate)
        ];
        if (facilityId) constraints.unshift(where("facility_id", "==", facilityId));
        const q = query(collection(db, "sessions"), ...constraints);
        batches.push(getDocs(q));
      }

      const snaps = await Promise.all(batches);
      snaps.forEach(snap => {
        snap.forEach(docSnap => results.push({ id: docSnap.id, ...docSnap.data() }));
      });

      // sortowanie po dacie+czasie
      results.sort((a,b) => {
        const ka = (a?.date || "") + (a?.startTime || "");
        const kb = (b?.date || "") + (b?.startTime || "");
        return ka.localeCompare(kb);
      });
      return results;
    };

    // === NEW: otwarcie popupu i usuwanie
    const openRemovePopup = () => {
      const d = new Date();
      const mm = String(d.getMonth() + 1).padStart(2, "0");
      const dd = String(d.getDate()).padStart(2, "0");
      setRemoveDate(`${d.getFullYear()}-${mm}-${dd}`);
      setRemoveOpen(true);
    };

    const confirmRemoval = async () => {
      try {
        setWorking(true);
        const facilityId = u?.acc?.facility_id;
        const groupIds = Array.isArray(u?.user?.groups) ? u.user.groups : [];
        const sessions = await fetchSessionsForGroupsFromDate(facilityId, groupIds, removeDate);

        // dla każdej sesji odfiltruj users, które mają uid === u.uid
        const tasks = sessions.map(s => {
          const nextUsers = (Array.isArray(s?.users) ? s.users : []).filter(x => x?.uid !== u?.uid);
          // jeśli bez zmian – pomiń
          if (nextUsers.length === (s?.users?.length || 0)) return Promise.resolve();
          return updateDoc(doc(db, "sessions", s.id), { users: nextUsers });
        });

        await Promise.all(tasks);
        console.log(`[REMOVE] Usunięto ${tasks.length} potencjalnych wpisów użytkownika ${u?.uid} od ${removeDate}.`);
        setRemoveOpen(false);
      } catch (e) {
        console.error("Błąd podczas usuwania z sesji:", e);
      } finally {
        setWorking(false);
      }
    };

        // Czytelny tytuł dokumentu
      const docLabel = (key, docs) => {
        if (key === "joinRequest") return "Wniosek o przyjęcie";
        if (key === "rules") return "Oświadczenie – regulamin";
        if (key === "parentStatement") return "Oświadczenie rodzica";
        if (key === "adultContract") return "Umowa (dorosły)";
        if (key === "contract") {
          const t = docs?.contract?.type;
          return t === "obligation" ? "Umowa (sezon)" : "Umowa";
        }
        return key;
      };

    const [extermination, setExtermination] = useState(false)
    const [exterminData, setExterminData] = useState(false)

    const exterminSet = () => {
      setDoc(doc(db, "users2026", u?.uid), {
          subUsers: {
              [u?.user?.index]: {
                  extermination: {
                    dateOfSet: exterminData?.dateOfSet,
                    endDate: exterminData?.endDate,
                    status: "active",
                  }
              }
          }
      }, {merge: true})

      setWhatsApp(false)
    }

    const galaSet = (status, gid) => {
      setDoc(doc(db, "users2026", u?.uid), {
          subUsers: {
              [u?.user?.index]: {
                  gala: {
                    [gid]: status === "yes" ? true : status === "no" ? false : status === "none" ? "none" : ""
                  }
              }
          }
      }, {merge: true})

      setGala(false)
    }

    const getGalaGroups = useCallback(() => {

    const grpArr = Array.isArray(groups) ? groups : [];
    const locArr = Array.isArray(locations) ? locations : [];


    return (u?.user?.groups || []).map((gId) => {
      const groupData = grpArr.find((x) => x?.id === gId);
      if (!groupData) return null;

      const locationName =
        locArr.find((x) => x?.id === groupData?.location_id)?.name || "";

      const dayData = groupData?.days?.[0];
      const dayInfo = dayData
        ? dayData.custom_name
          ? dayData.custom_name
          : `${numberToPolishWeekday(dayData.weekDay)} - ${dayData.startTime} - ${dayData.endTime} - ${groupData.type}`
        : "";

      return (
        <div style={({display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column", gap: "10px", width: "100%"})}>
          <div style={({display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "row", gap: "15px", width: "95%"})}>
            <Gala wth={"25px"} color={u?.user?.gala?.[groupData?.id] === true ? "#2e9428" : u?.user?.gala?.[groupData?.id] === false ? "#DC143C" : "rgb(30,30,30)"} curs={"default"}/>
            <h3 style={({fontSize: "13px", color: "rgb(30,30,30)", fontWeight: "normal"})}>{locationName} - {dayInfo}</h3>
          </div>
          <div style={({display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "row", gap: "20px", width: "95%", borderBottom: "1px solid rgba(30,30,30, 0.2)", paddingBottom: '15px'})}>
            <Gala wth={"30px"} color={"#2e9428"} curs={"pointer"} clickFunc={() => galaSet("yes", groupData?.id)}/>
            <Gala wth={"30px"} color={"rgb(30,30,30)"} curs={"pointer"} clickFunc={() => galaSet("none", groupData?.id)}/>
            <Gala wth={"30px"} color={"#DC143C"} curs={"pointer"} clickFunc={() => galaSet("no", groupData?.id)}/>
          </div>
        </div>
      );
    });
  }, [gala]);

  const GALA_COLORS = {
    success: "#2e9428",
    danger: "#DC143C",
    warning: "#e0b531",
    default: "rgb(30,30,30)",
  };

  const getGalaColor = (user) => {
    const prices = user?.prices;
    const gala = user?.gala;

    if (!prices || typeof prices !== "object") return GALA_COLORS.default;

    const groupIds = Object.keys(prices);
    if (!groupIds.length) return GALA_COLORS.default;

    if (!gala || typeof gala !== "object") return GALA_COLORS.default;

    const statuses = groupIds.map((groupId) => gala[groupId]);

    const allMissing = statuses.every((status) => status !== true && status !== false);
    if (allMissing) return GALA_COLORS.default;

    const hasMissing = statuses.some((status) => status !== true && status !== false);
    if (hasMissing) return GALA_COLORS.warning;

    if (statuses.every((status) => status === true)) return GALA_COLORS.success;
    if (statuses.every((status) => status === false)) return GALA_COLORS.danger;

    return GALA_COLORS.warning;
  };

// // === NEW: tours (tura/tury dla subUsera) ===
// const DEFAULT_TOUR = "1"; // <- tu sobie zmienisz ręcznie na inną (np. "2")

// const toursQuickSet = () => {
//   setDoc(
//     doc(db, "users2026", u?.uid),
//     {
//       subUsers: {
//         [u?.user?.index]: {
//           tours: [DEFAULT_TOUR], // array stringów
//         },
//       },
//     },
//     { merge: true }
//   );
// };

const ticketSet = () => {
  setDoc(
    doc(db, "users2026", u?.uid),
    {
      subUsers: {
        [u?.user?.index]: {
          ticket: true,
        },
      },
    },
    { merge: true }
  );
};

const holidaySet = (status) => {
  setDoc(
    doc(db, "users2026", u?.uid),
    {
      subUsers: {
        [u?.user?.index]: {
          holiday: status === "yes" ? true : status === "no" ? false : status === "none" ? "none" : ""
        },
      },
    },
    { merge: true }
  );
  setHoliday(false)
};

const newSeasonSet = (status) => {
  setDoc(
    doc(db, "users2026", u?.uid),
    {
      subUsers: {
        [u?.user?.index]: {
          new_season: status === "yes" ? true : status === "no" ? false : status === "none" ? "none" : ""
        },
      },
    },
    { merge: true }
  );
  setNewSeason(false)
};


    return (
        <div style={({display: "flex", justifyContent: "flex-start", alignItems: "center", flexDirection: "column", gap: "5px", borderBottom: "1px solid rgb(30,30,30,0.15)", padding: "5px", minWidth: "90%", transition: "0.5s"})}>
            <div style={({display: "flex", justifyContent: "flex-start", alignItems: "center", flexDirection: "row", gap: "10px", minWidth: "100%"})}>
                <div style={({display: 'flex', flexDirection: "row", justifyContent: "center", alignItems: "center", gap: "8px", marginRight: "5px"})}>
                    {u?.user?.extermination?.status === "active" && <Extermin wth={"23px"} color={"#DC143C"} curs={"default"}/>}
                    {/* <Gala wth={"20px"} color={getGalaColor(u?.user)} curs={"default"}/>
                    <TicketIcon wth={"20px"} color={u?.user?.ticket === true ? "#2e9428" : "rgb(30,30,30)"} curs={"default"}/> */}
                    <Season wth={"23px"} color={u?.user?.new_season === true ? "#2e9428" : u?.user?.new_season === false ? "#DC143C" : "rgb(30,30,30)"} curs={"default"}/>
                    <Holiday wth={"20px"} color={u?.user?.holiday === true ? "#2e9428" : u?.user?.holiday === false ? "#DC143C" : "rgb(30,30,30)"} curs={"default"}/>
                    {/* <WhatsApp wth={"20px"} color={u?.user?.whatsApp === "green" ? "#2e9428" : u?.user?.whatsApp === "send" ? "#e0b531" : u?.user?.whatsApp === "no" ? "#DC143C" : "rgb(30,30,30)"} curs={"default"}/> */}
                    {/* <Document wth={"17px"} color={u?.acc?.sign ? u?.acc?.confirm_docs ? "#0045C7" : "#e0b531" : "#DC143C"}/> */}
                </div>
                <div style={({display: 'flex', flexDirection: "column", justifyContent: "flex-start", alignItems: "flex-start", gap: "0px", width: "47.5%"})}>
                <h3 style={({fontSize: "12px", color: "rgb(30,30,30)"})}>
                  {u?.user?.displayName}
                  <span style={{ fontSize: "11px", color: "rgb(30,30,30,0.6)", marginLeft: "8px" }}>
                    tury: {Array.isArray(u?.user?.tours) && u.user.tours.length ? u.user.tours.join(",") : "-"}
                  </span>
                </h3>
                    <h3 style={({fontSize: "11px", color: "rgb(50,50,50)", fontWeight: 'normal'})}>{u?.acc?.parent?.displayName}</h3>
                </div>
                <div style={({display: 'flex', flexDirection: "column", justifyContent: "flex-start", alignItems: "flex-start", gap: "0px", width: "47.5%"})}>
                    <h3 style={({fontSize: "12px", color: "rgb(30,30,30)"})}>{u?.acc?.parent?.phone}</h3>
                    <h3 style={({fontSize: "11px", color: "rgb(50,50,50)", fontWeight: 'normal'})}>{u?.acc?.email}</h3>
                </div>
                {/* <div
                  style={({display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", height: "18px", width: "18px", borderRadius: "5px", backgroundColor: "rgb(0,0,0,0)", padding: "4px", border: "2px solid #0045C7", transition: "0.6s", cursor: "pointer"})}
                  onClick={toursQuickSet}
                  title={`Ustaw tours: ${DEFAULT_TOUR}`}
                >
                  <span style={{ fontSize: "11px", fontWeight: "900", color: "#0045C7", lineHeight: 1 }}>
                    T{DEFAULT_TOUR}
                  </span>
                </div> */}
                <div style={({display: 'flex', flexDirection: "row", justifyContent: "flex-start", alignItems: "flex-start", gap: "10px", marginRight: "5px"})}>

                    <div style={({display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", height: "18px", width: "18px", borderRadius: "5px", backgroundColor: "rgb(0,0,0,0)", padding: "3px", transition: "0.6s", marginTop: "3px", cursor: "pointer"})} onClick={() => setOn(!on)}>
                        <img src={on ? process.env.PUBLIC_URL + "/arrow_close.png" : process.env.PUBLIC_URL + "/arrow_open.png"} style={({width: "22px"})} />
                    </div>

                    {/* NEW: przycisk do uruchomienia usuwania od daty */}
                    {/* <button
                      onClick={openRemovePopup}
                      style={{padding:"4px 8px",border:"1px solid #0045C7",borderRadius:6,background:"#fff",color:"#0045C7",fontSize:11,cursor:"pointer",height:26,marginTop:2}}
                    >
                      Zakończ od daty
                    </button> */}
                </div>
            </div>
            {on &&
                <div style={({display: "flex", justifyContent: "flex-start", alignItems: "flex-start", flexDirection: "column", gap: "10px", width: "100%", transition: "0.5s", borderTop: "1px solid rgb(30,30,30,0.15)", paddingTop: "15px"})}> 
                    {getGroups()}
                    <div style={({display: 'flex', flexDirection: "row", justifyContent: "flex-start", alignItems: "flex-start", gap: "8px"})}>
                        <h3 style={({fontSize: "12px", color: "rgb(30,30,30, 0.9)", fontWeight: "normal", width: "100px"})}>Data urodzenia:</h3>
                        <h3 style={({fontSize: "12px", color: "rgb(30,30,30)"})}>{u?.user?.dateOfBirth}</h3>
                        <h3 style={({fontSize: "12px", color: "rgb(30,30,30)"})}>{u?.user?.pesel}</h3>
                    </div>
                    <div style={({display: 'flex', flexDirection: "row", justifyContent: "flex-start", alignItems: "flex-start", gap: "8px"})}>
                        <h3 style={({fontSize: "12px", color: "rgb(30,30,30, 0.9)", fontWeight: "normal", width: "100px"})}>Odbiór na zajęcia:</h3>
                        <h3 style={({fontSize: "12px", color: "rgb(30,30,30)"})}>{(u?.user?.pickUp && u?.user?.pickUp !== "brak") ? ((u?.user?.pickUp === "nie" || u?.user?.pickUp === "Nie") ? "Nie odbierać" : "Odebrać") + ((u?.user?.class && u?.user?.class !== "brak") ? " " + u?.user?.class : "") : "Nie dotyczy"}</h3>
                    </div>
                    <div style={({display: 'flex', flexDirection: "row", justifyContent: "flex-start", alignItems: "flex-start", gap: "8px"})}>
                        <h3 style={({fontSize: "12px", color: "rgb(30,30,30, 0.9)", fontWeight: "normal", width: "100px"})}>ID użytkownika:</h3>
                        <h3 style={({fontSize: "12px", color: "rgb(30,30,30)"})}>{u?.uid}</h3>
                    </div>
                    {u?.user?.extermination?.status === "active" && <div style={({display: 'flex', flexDirection: "row", justifyContent: "flex-start", alignItems: "center", gap: "8px"})}>
                        <h3 style={({fontSize: "12px", color: "rgb(30,30,30, 0.9)", fontWeight: "normal", width: "100px"})}>Wypowiedzenie złożono:</h3>
                        <h3 style={({fontSize: "12px", color: "rgb(30,30,30)"})}>{u?.user?.extermination?.dateOfSet}</h3>
                    </div>
                    }
                    {u?.user?.extermination?.status === "active" && <div style={({display: 'flex', flexDirection: "row", justifyContent: "flex-start", alignItems: "center", gap: "8px"})}>
                        <h3 style={({fontSize: "12px", color: "rgb(30,30,30, 0.9)", fontWeight: "normal", width: "100px"})}>Koniec okresu wypowiedzenia</h3>
                        <h3 style={({fontSize: "12px", color: "rgb(30,30,30)"})}>{u?.user?.extermination?.endDate}</h3>
                    </div>
                    }
                      {/* PODPISY DOKUMENTÓW + BRAKI */}
                      {(() => {
                        const docs = u?.user?.docs || {};

                        // podpisane (z obrazkiem podpisu)
                        const signed = Object.entries(docs)
                          .filter(([key, val]) =>
                            key !== "required" &&
                            val && typeof val === "object" &&
                            val.signed === true &&
                            !!val.sign
                          );

                        // wymagane (z required) i brakujące (niepodpisane)
                        const required = Array.isArray(docs?.required) ? docs.required : [];
                        const missing = required.filter((k) => docs?.[k]?.signed !== true);

                        if (signed.length === 0 && missing.length === 0) return null;

                        return (
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: 8,
                              width: "100%",
                              marginTop: 6,
                            }}
                          >
                            <h3
                              style={{
                                fontSize: 12,
                                color: "rgb(30,30,30)",
                                fontWeight: "bold",
                                margin: 0,
                              }}
                            >
                              Dokumenty
                            </h3>

                            <div
                              style={{
                                display: "grid",
                                gridTemplateColumns: "repeat(auto-fill, minmax(180px, 1fr))",
                                gap: 10,
                                width: "100%",
                              }}
                            >
                              {/* Podpisane */}
                              {signed.map(([key, val]) => (
                                <div
                                  key={`ok-${key}`}
                                  style={{
                                    border: "1px solid rgba(0,0,0,.12)",
                                    borderRadius: 8,
                                    padding: 8,
                                    background: "#fff",
                                  }}
                                >
                                  <div
                                    style={{
                                      fontSize: 11,
                                      color: "rgb(70,70,70)",
                                      fontWeight: 700,
                                      marginBottom: 6,
                                    }}
                                  >
                                    {docLabel(key, docs)}
                                  </div>

                                  <img
                                    src={val.sign}
                                    alt={`Podpis: ${docLabel(key, docs)}`}
                                    style={{
                                      width: "100%",
                                      height: 120,
                                      objectFit: "contain",
                                      background: "rgba(0,0,0,0.02)",
                                      border: "1px dashed rgba(0,0,0,.15)",
                                      borderRadius: 6,
                                    }}
                                  />

                                  <div
                                    style={{
                                      marginTop: 6,
                                      fontSize: 10,
                                      color: "rgb(110,110,110)",
                                    }}
                                  >
                                    {val?.date
                                      ? `Data: ${new Date(val.date).toLocaleDateString("pl-PL")}`
                                      : "Data: —"}
                                  </div>
                                </div>
                              ))}

                              {/* Braki (wymagane, ale niepodpisane) */}
                              {missing.map((key) => (
                                <div
                                  key={`miss-${key}`}
                                  style={{
                                    border: "1px solid rgba(220,38,38,.35)",
                                    borderRadius: 8,
                                    padding: 8,
                                    background: "rgba(254,242,242,.6)",
                                  }}
                                >
                                  <div
                                    style={{
                                      fontSize: 11,
                                      color: "#991B1B",
                                      fontWeight: 800,
                                      marginBottom: 6,
                                    }}
                                  >
                                    {docLabel(key, docs)}
                                  </div>

                                  <div
                                    style={{
                                      height: 120,
                                      display: "grid",
                                      placeItems: "center",
                                      border: "1px dashed rgba(220,38,38,.4)",
                                      borderRadius: 6,
                                      background:
                                        "repeating-linear-gradient(45deg, rgba(220,38,38,.05) 0 10px, rgba(220,38,38,.08) 10px 20px)",
                                    }}
                                  >
                                    <span style={{ fontSize: 11, color: "#B91C1C", fontWeight: 800 }}>
                                      BRAK PODPISU
                                    </span>
                                  </div>

                                  <div
                                    style={{
                                      marginTop: 6,
                                      fontSize: 10,
                                      color: "#991B1B",
                                    }}
                                  >
                                    Wymagany dokument nie został podpisany.
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        );
                      })()}
                    <div style={({display: 'flex', flexDirection: "row", justifyContent: "flex-start", alignItems: "flex-start", gap: "8px", marginTop: "5px", marginBottom: "3px"})}>
                        <Link style={({textDecoration: "none"})} to={"/listy/" + u?.uid} target="_blank">
                            <div style={({display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", height: "18px", width: "18px", borderRadius: "5px", backgroundColor: "rgb(0,0,0,0)", padding: "4px", border: "2px solid #0045C7", transition: "0.6s", cursor: "pointer"})}>
                                <img src={process.env.PUBLIC_URL + "/profile.png"} style={({width: "27px"})} />
                            </div>
                        </Link>
                        <div style={({display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", height: "18px", width: "18px", borderRadius: "5px", backgroundColor: "rgb(0,0,0,0)", padding: "4px", border: "2px solid #0045C7", transition: "0.6s", cursor: "pointer"})} onClick={(e) => {e?.stopPropagation(); copyToClipboard(u?.user?.displayName + " - " + u?.acc?.parent?.phone + " - " + u?.acc?.uid)}}>
                            <img src={process.env.PUBLIC_URL + "/clipboard.png"} style={({width: "25px"})} />
                        </div>
                        <div style={({display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", height: "18px", width: "18px", borderRadius: "5px", backgroundColor: "rgb(0,0,0,0)", padding: "4px", border: "2px solid #0045C7", transition: "0.6s", cursor: "pointer"})} onClick={() => setWhatsApp(!whatsApp)}>
                            <WhatsApp wth={"20px"} color="#0045C7"/>
                        </div>
                        <div style={({display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", height: "18px", width: "18px", borderRadius: "5px", backgroundColor: "rgb(0,0,0,0)", padding: "4px", border: "2px solid #0045C7", transition: "0.6s", cursor: "pointer"})} onClick={() => setExtermination(!extermination)}>
                            <Extermin wth={"20px"} color="#0045C7"/>
                        </div>
                        {/* <div style={({display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", height: "18px", width: "18px", borderRadius: "5px", backgroundColor: "rgb(0,0,0,0)", padding: "4px", border: "2px solid #0045C7", transition: "0.6s", cursor: "pointer"})} onClick={() => setGala(!gala)}>
                            <Gala wth={"20px"} color="#0045C7"/>
                        </div>
                        <div style={({display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", height: "18px", width: "18px", borderRadius: "5px", backgroundColor: "rgb(0,0,0,0)", padding: "4px", border: "2px solid #0045C7", transition: "0.6s", cursor: "pointer"})} onClick={() => ticketSet()}>
                            <TicketIcon wth={"20px"} color="#0045C7"/>
                        </div> */}
                        <div style={({display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", height: "18px", width: "18px", borderRadius: "5px", backgroundColor: "rgb(0,0,0,0)", padding: "4px", border: "2px solid #0045C7", transition: "0.6s", cursor: "pointer"})} onClick={() => setHoliday(!holiday)}>
                            <Holiday wth={"20px"} color="#0045C7"/>
                        </div>
                        <div style={({display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", height: "18px", width: "18px", borderRadius: "5px", backgroundColor: "rgb(0,0,0,0)", padding: "4px", border: "2px solid #0045C7", transition: "0.6s", cursor: "pointer"})} onClick={() => setNewSeason(!newSeason)}>
                            <Season wth={"20px"} color="#0045C7"/>
                        </div>
                    </div>
                </div>
            }
            {whatsApp && 
                <div style={({display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column", gap: "10px", width: "100%", height: "100%", transition: "0.5s", backgroundColor: "rgb(30,30,30,0.5)", position: "fixed", top: "0px", left: "0px", zIndex: "3000"})} onClick={() => setWhatsApp(false)}>
                    <div style={({display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column", gap: "10px", width: "300px", height: "200px", transition: "0.5s", backgroundColor: "rgb(250,250,250)", borderRadius: "5px"})} onClick={(e) => e.stopPropagation()}>
                        <h3 style={({fontSize: "13px", color: "rgb(30,30,30, 0.9)", fontWeight: "bold"})}>WhatsApp:</h3>
                        <div style={({display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "row", gap: "20px"})}>
                            <WhatsApp wth={"30px"} color="#2e9428" curs={"pointer"} clickFunc={() => whatsAppSet("green")}/>
                            <WhatsApp wth={"30px"} color="#e0b531" curs={"pointer"} clickFunc={() => whatsAppSet("send")}/>
                            <WhatsApp wth={"30px"} color="#DC143C" curs={"pointer"} clickFunc={() => whatsAppSet("no")}/>
                            <WhatsApp wth={"30px"} color="rgb(30,30,30)" curs={"pointer"} clickFunc={() => whatsAppSet("")}/>
                        </div>
                        <div style={({display: "flex", justifyContent: "center", alignItems: "flex-start", flexDirection: "column", gap: "5px", width: "300px", marginTop: "15px"})}>
                            <div style={({display: "flex", justifyContent: "center", alignItems: "flex-start", flexDirection: "row", gap: "5px", marginLeft: "20px"})}>
                                <div style={({backgroundColor: "#2e9428", width: "11px", height: "11px", borderRadius: "20px", marginTop: "3px"})}/>
                                <h3 style={({fontSize: "12px", color: "rgb(30,30,30)", fontWeight: "normal"})}>- jest w grupie</h3>
                            </div>
                            <div style={({display: "flex", justifyContent: "center", alignItems: "flex-start", flexDirection: "row", gap: "5px", marginLeft: "20px"})}>
                                <div style={({backgroundColor: "#e0b531", width: "11px", height: "11px", borderRadius: "20px", marginTop: "3px"})}/>
                                <h3 style={({fontSize: "12px", color: "rgb(30,30,30)", fontWeight: "normal"})}>- wysłane zaproszenie</h3>
                            </div>
                            <div style={({display: "flex", justifyContent: "center", alignItems: "flex-start", flexDirection: "row", gap: "5px", marginLeft: "20px"})}>
                                <div style={({backgroundColor: "#DC143C", width: "11px", height: "11px", borderRadius: "20px", marginTop: "3px"})}/>
                                <h3 style={({fontSize: "12px", color: "rgb(30,30,30)", fontWeight: "normal"})}>- nie chce być na grupie</h3>
                            </div>
                            <div style={({display: "flex", justifyContent: "center", alignItems: "flex-start", flexDirection: "row", gap: "5px", marginLeft: "20px"})}>
                                <div style={({backgroundColor: "rgb(30,30,30)", width: "11px", height: "11px", borderRadius: "20px", marginTop: "3px"})}/>
                                <h3 style={({fontSize: "12px", color: "rgb(30,30,30)", fontWeight: "normal"})}>- brak statusu</h3>
                            </div>
                        </div>
                    </div>
                </div>
            }
            {extermination && 
              <div style={({display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column", gap: "10px", width: "100%", height: "100%", transition: "0.5s", backgroundColor: "rgb(30,30,30,0.5)", position: "fixed", top: "0px", left: "0px", zIndex: "3000"})} onClick={() => {setExtermination(false); setExterminData("")}}>
                  <div style={({display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column", gap: "15px", width: "350px", height: "300px", transition: "0.5s", backgroundColor: "rgb(250,250,250)", borderRadius: "5px"})} onClick={(e) => e.stopPropagation()}>
                      <h3 style={({fontSize: "17px", color: "rgb(30,30,30, 0.9)", fontWeight: "bold", marginBottom: "15px"})}>Dodaj wypowiedzenie umowy</h3>
                      <div style={({display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column", gap: "10px", width: "100%"})}>
                        <h3 style={({fontSize: "13px", color: "rgb(30,30,30)", fontWeight: "normal"})}>Data złożenia wypowiedzenia</h3>
                        <input className="login" type="date" style={({height: "20px", width: "70%", fontgWeight: "bold", appearance: "none", border: "none", outline: "none", backgroundColor: "rgb(250,250,250)", padding: ".4em", color: "rgb(20,20,20)", backgroundImage: `url(${process.env.PUBLIC_URL + "/birthday.png"})`, backgroundSize: "17px", backgroundRepeat: "no-repeat", backgroundPosition: "7px 7px", paddingLeft: "40px", transition: "0.8s", borderBottom: ".2em solid rgb(20,20,20)"})} onChange={(e) => setExterminData({...exterminData, dateOfSet: e?.target?.value})}/>
                      </div>
                      <div style={({display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column", gap: "10px", width: "100%"})}>
                        <h3 style={({fontSize: "13px", color: "rgb(30,30,30)", fontWeight: "normal"})}>Data końca okresu wypowiedzenia</h3>
                        <input className="login" type="date" style={({height: "20px", width: "70%", fontgWeight: "bold", appearance: "none", border: "none", outline: "none", backgroundColor: "rgb(250,250,250)", padding: ".4em", color: "rgb(20,20,20)", backgroundImage: `url(${process.env.PUBLIC_URL + "/birthday.png"})`, backgroundSize: "17px", backgroundRepeat: "no-repeat", backgroundPosition: "7px 7px", paddingLeft: "40px", transition: "0.8s", borderBottom: ".2em solid rgb(20,20,20)"})} onChange={(e) => setExterminData({...exterminData, endDate: e?.target?.value})}/>
                      </div>
                      <div style={({display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "row", gap: "10px", width: "100%", marginTop: "15px"})}>
                      <button onClick={() => {exterminSet(); setExtermination(false); setExterminData("");}} style={({fontSize: "12px", color: "white", borderRadius: "5px", padding: "6px 20px"})} className="button-black">Dodaj wypowiedzenie</button>
                      <button onClick={() => {setExtermination(false); setExterminData("");}} style={({fontSize: "12px", color: "white", borderRadius: "5px", padding: "6px 20px"})} className="button-red">Anuluj</button>
                      </div>
                  </div>
              </div>
            }
            {gala && 
              <div style={({display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column", gap: "10px", width: "100%", height: "100%", transition: "0.5s", backgroundColor: "rgb(30,30,30,0.5)", position: "fixed", top: "0px", left: "0px", zIndex: "3000"})} onClick={() => setGala(false)}>
                  <div style={({display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column", gap: "15px", width: "350px", height: "fit-content", transition: "0.5s", backgroundColor: "rgb(250,250,250)", borderRadius: "5px", padding: "30px"})} onClick={(e) => e.stopPropagation()}>
                      <h3 style={({fontSize: "17px", color: "rgb(30,30,30, 0.9)", fontWeight: "bold", marginBottom: "15px"})}>Gala</h3>
                      {getGalaGroups()}
                  </div>
              </div>
            }

            {/* NEW: POPUP USUWANIA OD DATY */}
            {removeOpen && (
              <div
                style={{display:"flex",justifyContent:"center",alignItems:"center",flexDirection:"column",gap:"10px",width:"100%",height:"100%",transition:"0.3s",backgroundColor:"rgba(0,0,0,0.5)",position:"fixed",top:0,left:0,zIndex:4000}}
                onClick={() => !working && setRemoveOpen(false)}
              >
                <div
                  style={{display:"flex",flexDirection:"column",gap:12,width:"min(520px,92vw)",background:"#fff",borderRadius:12,padding:"16px 18px",boxShadow:"0 12px 28px rgba(0,0,0,.25)"}}
                  onClick={(e)=>e.stopPropagation()}
                >
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                    <h3 style={{margin:0,fontSize:16,color:"#111",fontWeight:800}}>Zakończ udział od daty</h3>
                    <span style={{fontSize:12,color:"#666"}}>{u?.user?.displayName}</span>
                  </div>

                  <label style={{fontSize:12,color:"#444"}}>Data (włącznie)</label>
                  <input
                    type="date"
                    value={removeDate}
                    onChange={e => setRemoveDate(e.target.value)}
                    disabled={working}
                    style={{height:36,padding:"6px 10px",border:"1px solid rgba(0,0,0,.2)",borderRadius:8,fontSize:13}}
                  />

                  <div style={{display:"flex",justifyContent:"flex-end",gap:8,marginTop:6}}>
                    <button onClick={()=>setRemoveOpen(false)} disabled={working} style={{padding:"8px 12px",border:"1px solid #aaa",borderRadius:8,background:"#fff",fontSize:12}}>
                      Anuluj
                    </button>
                    <button
                      disabled={working}
                      onClick={confirmRemoval}
                      style={{padding:"8px 12px",border:"none",borderRadius:8,background:"#0045C7",color:"#fff",fontWeight:800,fontSize:12,opacity:working?0.7:1,cursor:working?"not-allowed":"pointer"}}
                    >
                      {working ? "Usuwam..." : "Usuń z sesji od tej daty"}
                    </button>
                  </div>

                  <p style={{fontSize:12,color:"#777",margin:"6px 0 0"}}>
                    Operacja usuwa tę osobę z listy uczestników wszystkich przyszłych zajęć w jej grupach od wskazanej daty (włącznie).
                  </p>
                </div>
              </div>
            )}
            {holiday && 
                <div style={({display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column", gap: "10px", width: "100%", height: "100%", transition: "0.5s", backgroundColor: "rgb(30,30,30,0.5)", position: "fixed", top: "0px", left: "0px", zIndex: "3000"})} onClick={() => setHoliday(false)}>
                    <div style={({display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column", gap: "10px", width: "300px", height: "200px", transition: "0.5s", backgroundColor: "rgb(250,250,250)", borderRadius: "5px"})} onClick={(e) => e.stopPropagation()}>
                        <h3 style={({fontSize: "13px", color: "rgb(30,30,30, 0.9)", fontWeight: "bold"})}>Wakacyjne zajęcia:</h3>
                        <div style={({display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "row", gap: "20px"})}>
                            <Holiday wth={"30px"} color="#2e9428" curs={"pointer"} clickFunc={() => holidaySet("yes")}/>
                            <Holiday wth={"30px"} color="#DC143C" curs={"pointer"} clickFunc={() => holidaySet("no")}/>
                            <Holiday wth={"30px"} color="rgb(30,30,30)" curs={"pointer"} clickFunc={() => holidaySet("none")}/>
                        </div>
                        <div style={({display: "flex", justifyContent: "center", alignItems: "flex-start", flexDirection: "column", gap: "5px", width: "300px", marginTop: "15px"})}>
                            <div style={({display: "flex", justifyContent: "center", alignItems: "flex-start", flexDirection: "row", gap: "5px", marginLeft: "20px"})}>
                                <div style={({backgroundColor: "#2e9428", width: "11px", height: "11px", borderRadius: "20px", marginTop: "3px"})}/>
                                <h3 style={({fontSize: "12px", color: "rgb(30,30,30)", fontWeight: "normal"})}>- będzie chodzić</h3>
                            </div>
                            <div style={({display: "flex", justifyContent: "center", alignItems: "flex-start", flexDirection: "row", gap: "5px", marginLeft: "20px"})}>
                                <div style={({backgroundColor: "#DC143C", width: "11px", height: "11px", borderRadius: "20px", marginTop: "3px"})}/>
                                <h3 style={({fontSize: "12px", color: "rgb(30,30,30)", fontWeight: "normal"})}>- nie będzie chodzić</h3>
                            </div>
                            <div style={({display: "flex", justifyContent: "center", alignItems: "flex-start", flexDirection: "row", gap: "5px", marginLeft: "20px"})}>
                                <div style={({backgroundColor: "rgb(30,30,30)", width: "11px", height: "11px", borderRadius: "20px", marginTop: "3px"})}/>
                                <h3 style={({fontSize: "12px", color: "rgb(30,30,30)", fontWeight: "normal"})}>- brak statusu</h3>
                            </div>
                        </div>
                    </div>
                </div>
            }
             {newSeason && 
                <div style={({display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column", gap: "10px", width: "100%", height: "100%", transition: "0.5s", backgroundColor: "rgb(30,30,30,0.5)", position: "fixed", top: "0px", left: "0px", zIndex: "3000"})} onClick={() => setNewSeason(false)}>
                    <div style={({display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column", gap: "10px", width: "300px", height: "200px", transition: "0.5s", backgroundColor: "rgb(250,250,250)", borderRadius: "5px"})} onClick={(e) => e.stopPropagation()}>
                        <h3 style={({fontSize: "13px", color: "rgb(30,30,30, 0.9)", fontWeight: "bold"})}>Wakacyjne zajęcia:</h3>
                        <div style={({display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "row", gap: "20px"})}>
                            <Season wth={"30px"} color="#2e9428" curs={"pointer"} clickFunc={() => newSeasonSet("yes")}/>
                            <Season wth={"30px"} color="#DC143C" curs={"pointer"} clickFunc={() => newSeasonSet("no")}/>
                            <Season wth={"30px"} color="rgb(30,30,30)" curs={"pointer"} clickFunc={() => newSeasonSet("none")}/>
                        </div>
                        <div style={({display: "flex", justifyContent: "center", alignItems: "flex-start", flexDirection: "column", gap: "5px", width: "300px", marginTop: "15px"})}>
                            <div style={({display: "flex", justifyContent: "center", alignItems: "flex-start", flexDirection: "row", gap: "5px", marginLeft: "20px"})}>
                                <div style={({backgroundColor: "#2e9428", width: "11px", height: "11px", borderRadius: "20px", marginTop: "3px"})}/>
                                <h3 style={({fontSize: "12px", color: "rgb(30,30,30)", fontWeight: "normal"})}>- chętna na nowy sezon</h3>
                            </div>
                            <div style={({display: "flex", justifyContent: "center", alignItems: "flex-start", flexDirection: "row", gap: "5px", marginLeft: "20px"})}>
                                <div style={({backgroundColor: "#DC143C", width: "11px", height: "11px", borderRadius: "20px", marginTop: "3px"})}/>
                                <h3 style={({fontSize: "12px", color: "rgb(30,30,30)", fontWeight: "normal"})}>- rezygnują</h3>
                            </div>
                            <div style={({display: "flex", justifyContent: "center", alignItems: "flex-start", flexDirection: "row", gap: "5px", marginLeft: "20px"})}>
                                <div style={({backgroundColor: "rgb(30,30,30)", width: "11px", height: "11px", borderRadius: "20px", marginTop: "3px"})}/>
                                <h3 style={({fontSize: "12px", color: "rgb(30,30,30)", fontWeight: "normal"})}>- brak statusu</h3>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>
    )
}            
